import CartInner from '../components/Cart/CartInner'

const Cart = () => {
    return (
        <CartInner/>
    )
}

export default Cart
